// Packages
import { useState, useEffect, React } from "react";
import { Link, useParams } from "react-router-dom";
// Material Ui
import { Modal } from "react-bootstrap";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
// Styles
import "./schoolAdmin.css";
// Views
import SchoolAdminDashboard from "./schoolAdminDashboard";
// Services
import userService from "../../services/user.service";
// Utils
//assets
import nextarrow from "../../assets/images/nextarrow.png";
// import "../../../node_modules/gestalt/dist/gestalt.css";
import "../../../node_modules/gestalt/dist/gestalt.css";

import { Checkbox } from "gestalt";
import {
  getFromLocalStorage,
  setInToLocalStorage,
} from "../../utils/webStorage";
import { CircularProgress } from "@material-ui/core";
import { BsXLg } from "react-icons/bs";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  typography: {
    padding: theme.spacing(2),
  },
}));

function HighlightMerge() {
  const [checked, setChecked] = useState(false);
  //merge pop up
  const [openMerge, setOpenMerge] = useState(false);
  const [eventDetail, setEventDetail] = useState([]);
  const [showAllSelectedEventVideo, setShowAllSelectedEventVideo] = useState(
    []
  );
  const [showAllSelectedEventVideo1, setShowAllSelectedEventVideo1] = useState(
    []
  );
  const [selectedShow, setSelectedShow] = useState([]);
  const [checkedId, setCheckedId] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editedVideoName, setEditedVideoName] = useState("");
  const [mergeUrlVideo, setMergeUrlVideo] = useState("");
  const [eventId, setEventId] = useState(null);
  const [schoolId, setSchoolId] = useState(null);
  const [sendVideoToPdfTron, setSendVideoToPdfTron] = useState("");
  const [submitting, setSubmitting] = useState("");

  useEffect(() => {
    var schoolId = getFromLocalStorage("schoolId");
    setSchoolId(schoolId);
    loadDataOnlyEvent(schoolId);
  }, []);

  const loadDataOnlyEvent = (schoolId) => {
    userService.getAllEventLibrary(schoolId).then((res) => {
      var getAllEvents = res.data.data.events;
      setEventDetail(getAllEvents);
      // var totalEvents = res.data.data.total;
      // var totalPages = res.data.data.totalPages;
      // this.setState({ totalEvents,totalPages });
    });
  };

  const showSelectedEventVideosListing = (data) => {
    var showAllSelectedEventVideo = [];
    showAllSelectedEventVideo = data;
    setShowAllSelectedEventVideo(showAllSelectedEventVideo);
  };

  const onSelectedVideo = (e, video, i, id) => {
    var selectedFlag = e.checked;
    if (selectedFlag) {
      selectedShow.push(video);
      video.checked = true;
      setEventId(id);
      //   setCheckedId([...selectedShow])
      setShowAllSelectedEventVideo1([...selectedShow]);
    } else {
      showAllSelectedEventVideo1.splice(i, 1);
      setShowAllSelectedEventVideo1([...showAllSelectedEventVideo1]);
      setSelectedShow([...showAllSelectedEventVideo1]);
      video.checked = false;
    }
  };

  const handleToMerge = () => {
    setOpenMerge(true);
  };

  const handleCloseToMerge = () => {
    setOpenMerge(false);
  };

  const handleModelfiveOpen = () => {
    setSubmitting(true);
    // setShowModal(true);
    var arrayToMergeVideo = [];
    for (let i = 0; i < showAllSelectedEventVideo1.length; i++) {
      var obj = {};
      obj["fileName"] = showAllSelectedEventVideo1[i].videoPath;
      arrayToMergeVideo.push(obj);
    }
    mergeVideoForHighlight(arrayToMergeVideo);
  };

  const mergeVideoForHighlight = (arrayToMergeVideo) => {
    userService.mergeVideoApi(arrayToMergeVideo).then((res) => {
      var mergeVideoUrl = res.data.data;
      setMergeUrlVideo(mergeVideoUrl);
      savemergeHighlight(mergeVideoUrl);
    });
  };

  const savemergeHighlight = (mergeVideoUrl) => {
    userService
      .saveMergehighlight(schoolId, editedVideoName, mergeVideoUrl)
      .then((res) => {
        var finalUrl = res.data.data.videoPath;
        setInToLocalStorage("highlightedMergeVideoUrl", finalUrl);
        setSendVideoToPdfTron(finalUrl);
        handleModelfive();
        handleToMerge();
      });
  };

  const handleModelfive = () => {
    setShowModal(false);
  };

  return (
    <div className={submitting ? "gray-out" : " "}>
      <div id="highlight_S_create">
        <SchoolAdminDashboard />

        <div className="mTop">
          <div className="container">
            <div className="row justify-even">
              <div className="col-lg-3">
                <div className="cardSelectEvent" id="CardEVENT">
                  <div className="card-header">
                    <lable className="mb-0 fs-20 semibold">Select Event</lable>
                  </div>
                  <div className="card-body">
                    <div className="scroll">
                      {eventDetail &&
                        eventDetail.map((item, index) => (
                          <div
                            key={index}
                            className="teamBOX cp "
                            onClick={() =>
                              showSelectedEventVideosListing(item.eventMedias)
                            }
                          >
                            <div className="row">
                              <div className="col-6">
                                {item.team1 && item.team2 && (
                                  <label className="fs-18 medium black mb-0">
                                    {item.team1.teamName} VS{" "}
                                    {item.team2.teamName}
                                  </label>
                                )}
                                <p className="fs-18 semibold opacity07 pl-2">
                                  {item.eventMediaCount} Videos
                                </p>
                              </div>
                              <div className="col-6  text-right align-self">
                                <img src={nextarrow} alt="arrow"></img>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-3">
                <div className="cardSelectEvent" id="CardEVENT">
                  <div className="card-header">
                    <lable className="mb-0 fs-20 semibold">
                      LHS vs RHS (Choose Clips)
                    </lable>
                  </div>
                  <div className="card-body">
                    <div className="clear10"></div>
                    <div className="scroll">
                      {showAllSelectedEventVideo &&
                        showAllSelectedEventVideo.map((item, index) => (
                          <div key={index} className="row boxWhite">
                            <div className="col-lg-1 col-1 col-sm-1 align-self">
                              <Checkbox
                                checked={item.checked == true}
                                id={item.id}
                                name="usa"
                                onChange={(e) => {
                                  onSelectedVideo(e, item, index, item.id);
                                }}
                              />
                            </div>
                            <div className="col-lg-11 col-11 col-sm-11 pl-4">
                              <div className="row">
                                <div className="col-lg-4 align-self">
                                  <video
                                    src={item.videoPath}
                                    alt="hi"
                                    className="w-100"
                                  ></video>
                                </div>
                                <div className="col-lg-8 p-3">
                                  <p className="fs-18 semibold">
                                    {item.eventMediaCategory}
                                  </p>
                                  <div className="clear10"></div>
                                  <p className="opacity07 fs-14 medium">0.10</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div id="CardEVENT2">
                  <div className="card-header">
                    <lable className="mb-0 fs-20 semibold">
                      Your Selected Clips{" "}
                      <span className="black ">
                        ({[...showAllSelectedEventVideo1].length})
                      </span>
                    </lable>
                  </div>
                  <div className="card-body">
                    <div className="clear10"></div>
                    <div className="scroll">
                      {[...showAllSelectedEventVideo1] &&
                        [...showAllSelectedEventVideo1].map((item, index) => (
                          <div key={index} className="row ">
                            <div className="col-lg-11 pl-4">
                              <div className="row">
                                <div className="col-lg-4">
                                  <video
                                    src={item.videoPath}
                                    alt="hi"
                                    className="w-100"
                                  ></video>
                                </div>
                                <div className="col-lg-8 p-3">
                                  <p className="fs-18 semibold">
                                    {item.eventMediaCategory}
                                  </p>
                                  <div className="clear10"></div>
                                  <p className="opacity07 fs-14 medium">0.10</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-1">
                <button
                  className="mergeCLIPbtn fs-16 medium white cp"
                  onClick={handleModelfiveOpen}
                >
                  Merge Clips
                </button>
              </div>
            </div>
            <Dialog
              id="dialogBoxMerge"
              className="dialog-style"
              open={openMerge}
              onClose={handleToMerge}
            >
              <DialogTitle>
                <div className="row">
                  <div className="col-1 text-right ml-auto ">
                    <BsXLg
                      onClick={handleCloseToMerge}
                      className="crossview cp"
                    ></BsXLg>
                  </div>
                </div>
              </DialogTitle>
              <DialogContent>
                <div className="clear10"></div>
                <div className="row">
                  <div className="col-12 text-center">
                    <p className="fs-20 semi-bold text-center">
                      Merging of video completed.
                    </p>
                    <div className="clear30"></div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
                    <Link className="white" to="/PdfTronHighlight">
                      <button
                        type="button"
                        class="btnProceesnext   fs-14"
                        onClick={handleCloseToMerge}
                      >
                        Proceed
                      </button>
                    </Link>
                  </div>
                </div>

                <div className="clear10"></div>

                <div className="clear10"></div>
              </DialogContent>
            </Dialog>

            <Modal
              id="mwidth"
              show={showModal}
              onHide={() => {
                handleModelfive();
              }}
            >
              <Modal.Header closeButton></Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="col-md-6 col-lg-6">
                    <label className="fs-16 semi-bold black">
                      Enter the name for Highlighte video
                    </label>
                    <div className="clear10"></div>
                    <input
                      type="text"
                      className="olnone form-control regular"
                      placeholder="Enter video name"
                      value={editedVideoName}
                      onChange={(event) => {
                        setEditedVideoName(event.target.value);
                      }}
                    ></input>
                    <div className="errorMsg fs-14 medium">
                      {/* {errorPlaylistName} */}
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  type="button"
                  className="cancelbtn mr-2"
                  onClick={() => {
                    handleModelfive();
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="savebtn"
                  onClick={() => {
                    savemergeHighlight();
                  }}
                >
                  Save
                </button>
              </Modal.Footer>
            </Modal>

            {/*  */}
            {submitting && (
              <CircularProgress
                style={{
                  width: "45px",
                  height: "44px",
                  position: "absolute",
                  left: "50%",
                  top: "50%",
                  zIndex: "99",
                }}
                color="secondary"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default HighlightMerge;
